import { z } from 'zod';

export const emptyString = () => {
  return z.string().max(0);
};

export const requiredString = ({ t }) => {
  const message = t('inputs:required');

  return z.string({ message: message }).trim().min(1, message);
};
